import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

export class FloatTextInput extends Component {
    capValue = value => {
        if (this.props.maxValue) {
            return Math.min(value, this.props.maxValue);
        }
        return value;
    };

    onChange = e => {
        const value = e.target.value;
        if ((!isNaN(value) && this.negAllowed(value)) || this.isLeadingMinus(value)) {
            this.props.onChange(
                value.indexOf(".") !== -1
                    ? value.slice(0, value.indexOf(".") + this.props.decimalPlaces + 1)
                    : value
            );
        }
    };

    onBlur = e => {
        const value = e.target.value;
        if (!value || isNaN(parseFloat(value))) {
            this.props.onChange(
                this.props.defaultValue !== undefined
                    ? this.props.defaultValue
                    : parseFloat("0").toFixed(this.props.decimalPlaces)
            );
        } else {
            this.props.onChange(
                this.capValue(parseFloat(e.target.value)).toFixed(this.props.decimalPlaces)
            );
        }
    };

    isLeadingMinus = v => {
        return this.props.allowNegative && v === "-";
    };

    negAllowed = v => {
        return this.props.allowNegative || v > -1;
    };

    render() {
        return (
            <FloatInput
                id={this.props.id}
                type="text"
                value={this.props.value}
                onChange={this.onChange}
                onBlur={this.onBlur}
                onKeyPress={this.props.onKeyPress}
                disabled={this.props.disabled}
            />
        );
    }
}

export const FloatInput = styled.input`
    max-width: 100%;
    border: 1px solid #000;
    text-align: right;

    :disabled {
        cursor: not-allowed;
        background-color: #e6e6e6;
    }
`;

FloatTextInput.defaultProps = {
    decimalPlaces: 2,
    allowNegative: false,
    onKeyPress: () => {}
};

FloatTextInput.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    onKeyPress: PropTypes.func,
    decimalPlaces: PropTypes.number,
    allowNegative: PropTypes.bool,
    disabled: PropTypes.bool,
    defaultValue: PropTypes.string,
    maxValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
